export const ApiDataDemo = {
    title: 'MiracleWebAPI',
    version: '1.0',
    baseUrl: 'http://192.168.68.117:5000',
    endpoints: [
        {
            controllerName: 'ApplicatiofasdnLogs',
            httpMethod: 'Delete',
            path: '/api/application-log/{id}'
        },
        {
            controllerName: 'Applicfsadfation',
            httpMethod: 'Delete',
            path: '/api/application-log/{id}'
        },
        {
            controllerName: 'ApplicatiodasfnApi2',
            httpMethod: 'Delete',
            path: '/api/application-log/{id}'
        }
    ],
    demo: true
};

export default null;
